import { render, staticRenderFns } from "./POS.vue?vue&type=template&id=03b89ffe&scoped=true"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"
import style0 from "./POS.vue?vue&type=style&index=0&id=03b89ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b89ffe",
  null
  
)

export default component.exports